import { Field, GenericOption } from 'pages/AutomationEngine/types';
import { GoalDelay } from '../triggerSectionTypes';
import { DateOffset } from 'pages/AutomationEngine/helpers';

export const PastDateActionOptions = {
  PROCEED_DOWN_MET_PATH: 'proceed_down_met_path',
  PROCEED_DOWN_NOT_MET_PATH: 'proceed_down_not_met_path',
  WAIT_FOR_NOT_MET_PATH_DELAY: 'wait_for_not_met_path_delay',
} as const;

export type PastDateAction = ValueOf<typeof PastDateActionOptions>;

export type OnOrAroundDateGoalWaitType = 'never' | 'delay';

export type OnOrAroundDateGoalDateOffset = DateOffset;

export type OnOrAroundDateGoalPeriod = 'AM' | 'PM';

export type OnOrAroundDateGoalValue = {
  fieldId: (GenericOption & { fieldData: Field }) | null;
  dateOffset: OnOrAroundDateGoalDateOffset;
  time: string | null;
  period: OnOrAroundDateGoalPeriod | null;
  dateOffsetDays: number | null;
  everyYear: boolean;
  pastDateAction: PastDateAction;
} & Partial<GoalDelay>;
